import { Controller } from '@hotwired/stimulus';

// チェックボックスのまま GET で送ると店舗の数だけ値が並び、店舗の多い事業者で URL が nginx の上限 (8KB) を超える
// Analysis#pagination_params と同じく、カンマ区切りの 1 つの値にし、全店舗なら空にする
export default class extends Controller {
  static targets = ['item'];

  connect() {
    this.form = this.element.closest('form');
    this.compact = this.compact.bind(this);
    this.form?.addEventListener('submit', this.compact);
  }

  disconnect() {
    this.form?.removeEventListener('submit', this.compact);
  }

  // jquery_ujs は document で submit を受けて値を読むので、それより先に form で差し替える
  compact() {
    const items = this.itemTargets.filter((item) => item.name);
    if (items.length === 0) return;

    const name = items[0].name.replace(/\[\]$/, '');
    const selected = items.filter((item) => item.checked);
    for (const item of items) {
      item.dataset.shopBranchIdsParamName = item.name;
      item.removeAttribute('name');
    }

    // 全店舗でも空で送る、analysis が無いとサーバは送られていないとみなして保存済みの条件を使う
    const hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = name;
    hidden.value =
      selected.length === items.length
        ? ''
        : selected.map((item) => item.value).join(',');
    this.form.appendChild(hidden);

    // Ajax で送る画面はページが残るので、値を読み終えたあとで戻す
    setTimeout(() => {
      hidden.remove();
      for (const item of items) {
        item.name = item.dataset.shopBranchIdsParamName;
        delete item.dataset.shopBranchIdsParamName;
      }
    });
  }
}
